export const SENT_TO_BORROWER_LABEL = 'Sent to borrower';

export const DOWNLOAD_LABEL = 'Download';

export const OPEN_IN_NEW_TAB_LABEL = 'Open in new tab';
